import { EOrganizedBy } from 'detailsv2/structure';
import yup from 'utils/yup';

import { wrongTimeFormatError } from '../../constants';
import { optionalTimeFormatValidation, optionalTimeLengthValidation } from '../../functions';
import { endDateValidation, endDayValidation, startDateValidation, startDayValidation } from '../functions';

export const transferValidationSchema = (organizedBy: EOrganizedBy) => {
  const formFields: any = {
    attachedPages: yup.array().transform((arr: any[]) => arr.filter(Boolean)),
    data: yup.object().shape({
      departureFrom: yup.string().required('Please fill in this field'),
      arrivalTo: yup.string().required('Please fill in this field'),
      departureTime: yup
        .string()
        .test('dtime-len', wrongTimeFormatError, optionalTimeLengthValidation)
        .test('is-dtime-valid', wrongTimeFormatError, optionalTimeFormatValidation),
      arrivalTime: yup
        .string()
        .test('atime-len', wrongTimeFormatError, optionalTimeLengthValidation)
        .test('is-atime-valid', wrongTimeFormatError, optionalTimeFormatValidation),
    }),
  };

  if (organizedBy === EOrganizedBy.Date) {
    formFields.datesRange = yup.object().shape({
      start: yup.string().required('Please fill in this field').lesserThanEndDate().nullable(),
      end: yup.string().required('Please fill in this field').greaterThanStartDate().nullable(),
    });
  }

  if (organizedBy === EOrganizedBy.Day) {
    formFields.daysRange = yup.object().shape({
      start: yup.number().required('Please fill in this field').lesserThanEndDay().nullable(),
      end: yup.number().required('Please fill in this field').greaterThanStartDay().nullable(),
    });
  }

  return yup.object().shape({
    ...formFields,
  });
};

yup.addMethod(yup.number, 'greaterThanStartDay', function (this: any) {
  return this.test({
    message: 'End date must be on or after start date',
    name: 'is-greater-than-start-day',
    test: endDayValidation,
  });
});

yup.addMethod(yup.number, 'lesserThanEndDay', function (this: any) {
  return this.test({
    message: 'End date must be on or after start date',
    name: 'is-lesser-than-end-day',
    test: startDayValidation,
  });
});

yup.addMethod(yup.string, 'greaterThanStartDate', function (this: any) {
  return this.test({
    message: 'End date must be on or after start date',
    name: 'is-greater-than-start-date',
    test: endDateValidation,
  });
});

yup.addMethod(yup.string, 'lesserThanEndDate', function (this: any) {
  return this.test({
    message: 'End date must be on or after start date',
    name: 'is-lesser-than-end-date',
    test: startDateValidation,
  });
});
